<template>
  <q-menu :offset="[0, 8]" anchor="bottom middle" self="top middle" fit>
    <slot name="default">
      <q-list>
        <q-item
          v-for="({ label, value, onClick }, index) in props.menuItems"
          :key="index"
          v-close-popup
          :focused="isFocused(label, value)"
          clickable
          dense
          @click="() => onClick(value ?? label)"
        >
          <q-item-section no-wrap>
            <q-item-label
              :title="label"
              class="text-primary text-sm flex items-center"
              lines="1"
            >
              <span>{{ label }}</span>
              <CheckMarkIcon
                v-if="isFocused(label, value)"
                class="icon--sm q-ml-xxs"
              />
            </q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </slot>
  </q-menu>
</template>

<script setup>
import CheckMarkIcon from "assets/icons/checkmark.svg";

const props = defineProps({
  menuItems: {
    type: Array,
    default: () => [],
  },
  selected: {
    type: String,
    default: "",
  },
});

const isFocused = (label, value) => {
  let selected = value ?? label;

  return selected === props.selected;
};
</script>
